import React, {useEffect, useState} from 'react';

import FormComponentV2 from '../common/genericComponents/redesign/formComponentV2/formComponentV2';
import InputComponentV2 from '../common/genericComponents/redesign/inputComponentV2/inputComponentV2';
import MultiCheckBoxComponent from '../common/genericComponents/redesign/multiCheckBoxComponent/multiCheckBoxComponent';
import MultiRadioButtonComponent from '../common/genericComponents/redesign/multiRadioButtonComponent/multiRadioButtonComponent';
import SeparatorComponent from '../common/genericComponents/separatorComponent/separatorComponent';

import './moveChatPopup.css';

const RADIO_BTN_IDS = {
  ASSIGN_ONLY: 'ASSIGN_ONLY',
  ASSIGN_AND_COPY: 'ASSIGN_AND_COPY',
};

const RADIO_BUTTON_OPTIONS = [
  {
    id: RADIO_BTN_IDS.ASSIGN_ONLY,
    titleTxt: 'Assign only',
    subTitleTxt: 'Will transfer ownership to the agent',
  },
  {
    id: RADIO_BTN_IDS.ASSIGN_AND_COPY,
    titleTxt: 'Assign & copy information',
    subTitleTxt:
      'Will transfer ownership to the agent and copy customer information to the private chat',
  },
];

const CLONE_RECIPE_OPTION_IDS = {
  NAME: 'NAME',
  EMAIL: 'EMAIL',
  PHONE_NUMBER: 'PHONE_NUMBER',
};

const CLONE_RECIPE_OPTIONS = [
  {
    key: CLONE_RECIPE_OPTION_IDS.NAME,
    label: 'Name',
  },
  {
    key: CLONE_RECIPE_OPTION_IDS.EMAIL,
    label: 'Email',
  },
  {
    key: CLONE_RECIPE_OPTION_IDS.PHONE_NUMBER,
    label: 'Phone number',
  },
];

const MoveChatPopup = ({
  isDisabled = false,
  chatRoom = {},
  formTitle = 'Move to one-on-one conversation',
  onCancel = () => {},
  onTransition = () => {},
}) => {
  const [selectedMoveChatOption, setSelectedMoveChatOption] = useState(
    RADIO_BTN_IDS.ASSIGN_ONLY,
  );
  const [selectedOptionsKeys, setSelectedOptionsKeys] = useState([]);
  const [roomNotes, setRoomNotes] = useState('');

  useEffect(() => {
    const selectedOptionsKeys = Object.keys(CLONE_RECIPE_OPTION_IDS);
    setSelectedOptionsKeys(selectedOptionsKeys);
    setRoomNotes(chatRoom.roomInfoDto?.notes ?? '');
  }, []);

  const onTransitionBtnClicked = () => {
    if (selectedMoveChatOption === RADIO_BTN_IDS.ASSIGN_AND_COPY) {
      const {peerName, peerEmail, peerPhoneNumber} =
        chatRoom.chatRoomPeerInfoDto;
      const chatRoomPeerInfoDto = {
        ...(selectedOptionsKeys.includes(CLONE_RECIPE_OPTION_IDS.NAME) &&
          peerName && {peerName}),
        ...(selectedOptionsKeys.includes(CLONE_RECIPE_OPTION_IDS.EMAIL) &&
          peerEmail && {peerEmail}),
        ...(selectedOptionsKeys.includes(
          CLONE_RECIPE_OPTION_IDS.PHONE_NUMBER,
        ) &&
          peerPhoneNumber && {peerPhoneNumber}),
      };

      let transitionChatRoomCloneRecipe = Object.keys(chatRoomPeerInfoDto)
        .length
        ? {chatRoomPeerInfoDto}
        : null;

      if (roomNotes?.length) {
        if (!transitionChatRoomCloneRecipe) {
          transitionChatRoomCloneRecipe = {};
        }
        transitionChatRoomCloneRecipe.roomInfoDto = {notes: roomNotes};
      }
      onTransition(transitionChatRoomCloneRecipe);
    } else {
      onTransition();
    }
  };

  const handleRadioBtnClicked = (id, value) => {
    setSelectedMoveChatOption(value);
  };

  const onCheckboxClicked = (mainCheckBoxId, selectedCheckBoxId) => {
    let selectedKeys = [...selectedOptionsKeys];
    const selectedOptionIdx = selectedKeys.findIndex(
      (key) => key === selectedCheckBoxId,
    );
    if (selectedOptionIdx === -1) {
      selectedKeys.push(selectedCheckBoxId);
    } else {
      selectedKeys.splice(selectedOptionIdx, 1);
    }
    setSelectedOptionsKeys(selectedKeys);
  };

  const handleChange = (id, value) => {
    setRoomNotes(value);
  };

  return (
    <div className="et-v2-move-chat-popup-container">
      <FormComponentV2
        isRightBtnDisabled={false}
        formTitle={formTitle}
        leftBtnTxt="Cancel"
        rightBtnTxt="Transition to one-on-one"
        onLeftBtnClicked={onCancel}
        onRightBtnClicked={onTransitionBtnClicked}>
        <SeparatorComponent />
        <MultiRadioButtonComponent
          id="moveChatPopup"
          isDisabled={isDisabled}
          options={RADIO_BUTTON_OPTIONS}
          selectedRadioBtnId={selectedMoveChatOption}
          onRadioBtnClicked={handleRadioBtnClicked}
        />
        <SeparatorComponent />
        {selectedMoveChatOption === RADIO_BTN_IDS.ASSIGN_AND_COPY && (
          <>
            <MultiCheckBoxComponent
              id="sessionMode"
              isDisabled={isDisabled}
              options={CLONE_RECIPE_OPTIONS}
              selectedOptionsKeys={selectedOptionsKeys}
              subTitleTxt="Select one or more options you want to copy to the new room."
              titleTxt="Copy customer information"
              toolTipTxt="Select one or more option you want to copy to the new room. You can update these later."
              onCheckboxClicked={onCheckboxClicked}
            />
            <SeparatorComponent isSmall />
            <InputComponentV2
              id="notes"
              hideCharacterCount
              noWaitOnInput={true}
              defaultValue={roomNotes}
              inputType="textarea"
              maxLength={500}
              placeholder="Write your notes here"
              onChange={handleChange}
            />
            <SeparatorComponent />
          </>
        )}
      </FormComponentV2>
    </div>
  );
};

export default MoveChatPopup;
